import * as React from 'react';
import { forwardRef } from "react";
import { clsx } from 'clsx';
import { hexBrightness } from "../helpers/colorUtils.ts";

interface Props extends React.ComponentPropsWithRef<"div"> {
	className?: string,
	children?: React.ReactNode,
	color?: string,
	selected?: boolean
}

const ColorSwatch = forwardRef<HTMLDivElement, Props>(function(
	{
		color = null,
		className = '',
		children = null,
		selected = false,
		...otherProps
	}: Props,
	ref
) {
	return (<>
		<div className={clsx(
			"min-w-[30px] h-[30px] rounded-lg cursor-pointer leading-7 px-1 text-center",
			selected ? 'border-primary-admin-200' : 'border-grey-100',
			selected ? 'shadow-[0_0_0_1px_rgba(150,181,140,1),_inset_0_0_0_1px_rgba(0,0,0,0.2)]' : 'shadow-[0_0_0_1px_rgba(0,0,0,0.2),_inset_0_0_0_1px_rgba(0,0,0,0.2)]',
			"border-[3px] border-solid hover:border-primary-admin-200",
			(color && hexBrightness(color) < 128) ? 'text-white' : 'text-black',
			className
		)}
		     ref={ref}
		     style={{backgroundColor: color}}
		     {...otherProps}
		>
			{children}
		</div>
	</>);
});

export default ColorSwatch;
